import { render, staticRenderFns } from "./textElementNew.vue?vue&type=template&id=73e57ea7&scoped=true&"
import script from "./textElementNew.vue?vue&type=script&lang=js&"
export * from "./textElementNew.vue?vue&type=script&lang=js&"
import style0 from "./textElementNew.vue?vue&type=style&index=0&id=73e57ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e57ea7",
  null
  
)

export default component.exports